<div class="panel" *ngIf="breakdown">
    <div class="panel_title">
        Product Details
    </div>

    <div class="panel_devider"></div>

    <div class="panel-header">
        <div class="panel-header_image">
            <img class="panel-header_image-inner" [src]="product.Image" alt="" />
        </div>
        <div class="panel-header_title">{{ product.Title }}</div>

        <div class="panel-header_chips">
            <app-sku-chip [name]="'Name'" [value]="product.Name"></app-sku-chip>
        </div>
    </div>
    <div class="panel-detail">
        <span><span class="label">Vendor</span> <br> {{breakdown.vendor}}</span>
        <span><span class="label">Lead time</span> <br> {{breakdown.leadDays}} days <br><span class="label">({{breakdown.leadDateFrom | date:'MM/dd/yy'}} - {{breakdown.leadDateTo | date:'MM/dd/yy'}})</span></span>
        <span><span class="label">Purchasing for</span> <br> {{breakdown.purchasingDay}} days <br><span class="label">({{breakdown.purchasingDateFrom | date:'MM/dd/yy'}} - {{breakdown.purchasingDateTo | date:'MM/dd/yy'}})</span></span>
       
    </div>


    <div class="section">
        <div class="section_title">SKU Demand</div>
        <div class="section_content">
            <app-breakdown-header [title]="'Total SKU demand'" [isEditable]="false" [isExpandable]="true" [total]="breakdown.skuDemandTotal">
                <app-smart-data-grid
                    [gridOptions]="skuDemandGridOptions"
                ></app-smart-data-grid>
            </app-breakdown-header>
        </div>
        <div class="section_summary">
            Total Demand: {{ breakdown.skuDemandTotal | number}}
        </div>
    </div>

    <div class="section">
        <div class="section_title">Additional Item Demand</div>
        <div class="section_content">
            <app-breakdown-header (valueChanges)="totalChanged('eventsTotal', $event)"  [title]="'Events'" [isEditable]="false" [isExpandable]="true" [total]="breakdown.eventsTotal">
                <div class="list">
                    <div class="list_item list_item--events" *ngFor="let event of breakdown.events">
                        <div class="list_actions">
                            <i class="far fa-trash-alt" (click)="deleteEvent(event.productEventId)"></i>
                            <i class="far fa-edit" (click)="addEvent(event)"></i>
                        </div>
                        <div class="list_title">{{event.eventDate |  date:'MM/dd/yyyy'}}</div>
                        <div class="list_description">{{event.description}}</div>
                        <div class="list_total">{{event.amount  | number: '1.0-0'}}</div>
                    </div>

                    <div class="list_action">
                        <app-button [buttonStyle]="'text'" (click)="addEvent()">Add Event</app-button>
                    </div>
                </div>
            </app-breakdown-header>
        </div>

        <div class="section_content">
            <app-breakdown-header (valueChanges)="totalChangedWithRecalculate('demandBufferTotal', $event)"  [title]="'Buffer Amount'" [isEditable]="true" [isExpandable]="true" [total]="breakdown.demandBuffers[1].amount">
                <div class="list">
                    <div class="list_item list_item--buffer">
                        <div class="list_title">{{breakdown.demandBuffers[1].title }}</div>
                        <div class="list_total">{{breakdown.demandBuffers[1].amount  | number: '1.0-0'}}</div>
                    </div>
                </div>
            </app-breakdown-header>
        </div>

        <div class="section_content">
            <app-breakdown-header (valueChanges)="totalChangedWithRecalculate('seasonsTotal' ,$event)"  [title]="'Season Adjustments'" [isEditable]="true" [isExpandable]="true" [total]="breakdown.seasonsTotal">
                <div class="list">
                    <div class="list_item list_item--events" *ngFor="let season of breakdown.seasons">
                        <div class="list_actions">
                            <i class="far fa-trash-alt" (click)="removeSeason(season.seasonId)"></i>
                        </div>
                        <div class="list_title">{{season.seasonName}}</div>
                        <div class="list_description">{{season.startDate  |  date:'MM/dd'}} - {{season.endDate  |  date:'MM/dd'}}</div>
                        <div class="list_total">{{season.amountChange}} ({{season.percentageChange}}%)</div>
                    </div>

                    <div class="list_action">
                        <app-button [buttonStyle]="'text'" (click)="addSeason()">Add Season</app-button>
                    </div>
                </div>
            </app-breakdown-header>
        </div>

        <div class="section_content">
            <app-breakdown-header   [title]="'Applied Seasonal Velocity'" [isEditable]="false" [isExpandable]="false" [total]="isSeasonalApplied ? appliedSeasonalVelocity : 0">
                
            </app-breakdown-header>
        </div>


        <div class="section_summary">
            Total Additional Item Demand : {{additionalDemandTotal | number: '1.0-0'}}
        </div>
    </div>


    <div class="section">
        <div class="section_title">Stock</div>
        <div class="section_content">
            <app-breakdown-header [title]="'Deducted due to FBA'" [isEditable]="false" [isExpandable]="true" [total]="breakdown.skuFbaTotal | number: '1.0-0'">
                <app-smart-data-grid
                    [gridOptions]="deductDueToFbaGridOptions"
                ></app-smart-data-grid>
            </app-breakdown-header>
        </div>

        <div class="section_content">
            <app-breakdown-header [title]="'Local Stock'" [isEditable]="false" [isExpandable]="true" [total]="breakdown?.warehouseStock - breakdown.demandBuffers[0].amount">
                <div class="list">
                    <div class="list_item list_item--buffer">
                        <div class="list_title">Available Stock</div>
                        <div class="list_total">{{breakdown?.warehouseStock  | number: '1.0-0'}}</div>
                    </div>
                    <div class="list_item list_item--buffer">
                        <div class="list_title">{{breakdown.demandBuffers[0].title}}</div>
                        <div class="list_total">- {{breakdown.demandBuffers[0].amount  | number: '1.0-0'}}</div>
                    </div>
                </div>
            </app-breakdown-header>
        </div>

        <div class="section_content">
            <app-breakdown-header [title]="'Draft PO\'s'" [isEditable]="false" [isExpandable]="true"  [total]="breakdown.draftPoTotal | number: '1.0-0'">
                <app-smart-data-grid
                    [gridOptions]="draftPoGridOptions"
                ></app-smart-data-grid>
            </app-breakdown-header>
        </div>

        <div class="section_content">
            <app-breakdown-header [title]="'Inbound PO\'s'" [isEditable]="false" [isExpandable]="true"  [total]="breakdown.inboundPoTotal  | number: '1.0-0'">
                <app-smart-data-grid
                    [gridOptions]="inboundPoGridOptions"
                ></app-smart-data-grid>
            </app-breakdown-header>
        </div>


        <div class="section_summary">
            Total Stock: {{stockTotal | number: '1.0-0'}}
        </div>
    </div>

    <div class="panel-pusher"></div>

    <div class="panel-footer">
        <div class="panel-footer_title">Total Suggestion: </div>
        <input type="number" [formControl]="suggestionSelection" class="panel-footer_input">
        <app-button [buttonStyle]="'text'" (click)="selectSuggestionValue()">Suggestion Qty: {{suggestionTotal | number: '1.0-0'}}</app-button>
    </div>
</div>

<div class="no-results" *ngIf="!breakdown">
    <app-no-results [message]="'Loading Product Information'"></app-no-results>
</div>
